/* MetaPro B2B — shared lead submission.
   Posts through Shopify's native /contact endpoint so enquiries arrive by email
   with no third-party app. Falls back to WhatsApp if the post fails.

   Shopify's contact notification subject is always the generic "New customer message",
   and it cannot be changed. The Name field is what shows in the inbox preview, so we
   prefix it with a source tag and the company — that is the only way to tell a
   lakh-value manufacturing enquiry from a retail question at a glance.
   The tag is derived from the page URL, so the calling scripts need no changes. */
(function(){
'use strict';
window.MPLead = window.MPLead || {};

window.MPLead.WA = '919815118798';

window.MPLead.ref = function(prefix){
  var d = new Date();
  var stamp = String(d.getFullYear()).slice(2)
    + String(d.getMonth()+1).padStart(2,'0')
    + String(d.getDate()).padStart(2,'0')
    + '-' + String(d.getHours()).padStart(2,'0') + String(d.getMinutes()).padStart(2,'0');
  return (prefix||'MPL') + '-' + stamp;
};

function v(id){ var e=document.getElementById(id); return e ? e.value.trim() : ''; }

function context(){
  var p = (window.location.pathname||'').toLowerCase();
  if(p.indexOf('third-party-manufacturing') > -1){
    var t = document.getElementById('mpb-sType');
    var q = document.getElementById('mpb-sQty');
    var bits = [];
    if(t && t.textContent && t.textContent !== '—') bits.push(t.textContent.trim());
    if(q && q.textContent && q.textContent !== '—') bits.push(q.textContent.trim());
    return { tag:'MANUFACTURING', company: v('mpb-co'), summary: bits.join(', ') };
  }
  if(p.indexOf('raw-whey') > -1){
    var kg = document.getElementById('mpw-kg');
    return { tag:'RAW WHEY', company: v('mpw-co'), summary: kg ? (kg.textContent.trim()+' kg') : '' };
  }
  return { tag:'', company:'', summary:'' };
}

window.MPLead.send = function(o){
  var c = context();
  var tag     = o.tag     || c.tag;
  var company = o.company || c.company;
  var summary = o.summary || c.summary;

  var label = o.name || 'Website enquiry';
  if(company) label += ' — ' + company;
  if(summary) label += ' — ' + summary;
  if(tag)     label = '[' + tag + '] ' + label;

  var fd = new FormData();
  fd.append('form_type','contact');
  fd.append('utf8','✓');
  fd.append('contact[name]', label);
  if(o.email) fd.append('contact[email]', o.email);
  if(o.phone) fd.append('contact[phone]', o.phone);
  fd.append('contact[body]', o.body || '');
  return fetch('/contact', { method:'POST', body: fd, headers:{'Accept':'text/html'} })
    .then(function(r){ return r.ok; })
    .catch(function(){ return false; });
};

window.MPLead.waLink = function(text){
  return 'https://wa.me/' + window.MPLead.WA + '?text=' + encodeURIComponent(text);
};
})();
